import { render, staticRenderFns } from "./EthicalList.vue?vue&type=template&id=333c56e2"
import script from "./EthicalList.vue?vue&type=script&lang=js"
export * from "./EthicalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports